import InboxClassificationFilter from 'owa-mail-inbox-plus-store/lib/store/schema/InboxClassificationFilter';

// Get the string used in the UserConfiguration InboxTabs property
export default function getUserConfigurationTabFromInboxClassificationFilter(
    inboxClassificationFilter: InboxClassificationFilter
): string {
    switch (inboxClassificationFilter) {
        case InboxClassificationFilter.None:
            return 'Inbox';
        case InboxClassificationFilter.Focused:
            return 'Focused';
        case InboxClassificationFilter.Promotions:
            return 'Promotions';
        case InboxClassificationFilter.Social:
            return 'Social';
        case InboxClassificationFilter.Newsletters:
            return 'Newsletters';
        case InboxClassificationFilter.Other:
            return 'Other';
        default:
            throw new Error('Unknown InboxClassificationFilter type');
    }
}
